import {
  type ChartType,
  isCompensationChartType,
  isCompositionChartType,
  isPostingChartType,
  isScreenerChartType,
  isSentimentChartType,
  isTransitionChartType,
} from '../../PageConfigProvider/types/chart';
import type { SecondaryDimensionValues } from '../../PageConfigProvider/types/dimension';
import {
  isCompensationSecondaryDimension,
  isPostingSecondaryDimension,
  isTransitionSecondaryDimension,
} from '../../PageConfigProvider/types/dimension';
import {
  type CompositionMetricValues,
  isCompositionRoutableMetric,
  isPayMetric,
  isPostingMetric,
  isScreenerMetric,
  isSentimentMetric,
  isTransitionMetric,
  type MetricValues,
  type PayMetricValues,
  type PostingMetricValues,
  type ScreenerMetricValues,
  type SentimentMetricValues,
  type TransitionMetricValues,
} from '../../PageConfigProvider/types/metric';

export function routesToComposition(
  metric: MetricValues,
  chartType: ChartType
): metric is CompositionMetricValues {
  return (
    isCompositionRoutableMetric(metric) && isCompositionChartType(chartType)
  );
}

export function routesToTransition(
  metric: MetricValues,
  chartType: ChartType,
  secondaryDimension: SecondaryDimensionValues | undefined
): metric is TransitionMetricValues {
  return (
    isTransitionMetric(metric) &&
    isTransitionChartType(chartType) &&
    (!secondaryDimension || isTransitionSecondaryDimension(secondaryDimension))
  );
}

export function routesToPosting(
  metric: MetricValues,
  chartType: ChartType,
  secondaryDimension: SecondaryDimensionValues | undefined
): metric is PostingMetricValues {
  return (
    isPostingMetric(metric) &&
    isPostingChartType(chartType) &&
    (!secondaryDimension || isPostingSecondaryDimension(secondaryDimension))
  );
}

export function routesToSentiment(
  metric: MetricValues,
  chartType: ChartType
): metric is SentimentMetricValues {
  return isSentimentMetric(metric) && isSentimentChartType(chartType);
}

export function routesToCompensation(
  metric: MetricValues,
  chartType: ChartType,
  secondaryDimension: SecondaryDimensionValues | undefined
): metric is PayMetricValues {
  return (
    isPayMetric(metric) &&
    isCompensationChartType(chartType) &&
    (!secondaryDimension ||
      isCompensationSecondaryDimension(secondaryDimension))
  );
}

export function routesToScreener(
  metric: MetricValues,
  chartType: ChartType
): metric is ScreenerMetricValues {
  return isScreenerMetric(metric) && isScreenerChartType(chartType);
}

export function isSentimentSnapshotChartType(chartType: ChartType): boolean {
  return (
    chartType === 'bar' ||
    chartType === 'diverging-bar' ||
    chartType === 'diverging-bar-combo'
  );
}
